import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { PresetDateFormat } from "@faire/web--source/common/FaireDateRange";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var OpenSizingVariationHelper = function(param) {
    var variation = param.variation;
    var shipDate = variation.showDatesInQuanitityPicker ? variation.expectedShipDate : undefined;
    var orderByDate = variation.showDatesInQuanitityPicker ? variation.orderByDate : undefined;
    if (!shipDate) {
        return null;
    }
    var _shipDate_formatPresetDateRange, _shipDate_formatPresetDateRange1;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "labelSansRegular",
        color: Core.text.subdued,
        "data-test-id": "open-sizing-".concat(variation.size, "-variation-shipping-suffix"),
        children: orderByDate ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "C/nVmr",
            defaultMessage: [
                {
                    type: 0,
                    value: "Preorder "
                },
                {
                    type: 1,
                    value: "shippingDate"
                },
                {
                    type: 0,
                    value: ". Order must be placed by "
                },
                {
                    type: 1,
                    value: "orderByDate"
                },
                {
                    type: 0,
                    value: "."
                }
            ],
            values: {
                shippingDate: (_shipDate_formatPresetDateRange = shipDate === null || shipDate === void 0 ? void 0 : shipDate.formatPresetDateRange(PresetDateFormat.ABBREVIATED_MMM_D)) !== null && _shipDate_formatPresetDateRange !== void 0 ? _shipDate_formatPresetDateRange : "",
                orderByDate: intlDate(orderByDate.localDateObject, "MMM d")
            }
        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "7jcEyT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Preorder "
                },
                {
                    type: 1,
                    value: "shippingDate"
                }
            ],
            values: {
                shippingDate: (_shipDate_formatPresetDateRange1 = shipDate === null || shipDate === void 0 ? void 0 : shipDate.formatPresetDateRange(PresetDateFormat.ABBREVIATED_MMM_D)) !== null && _shipDate_formatPresetDateRange1 !== void 0 ? _shipDate_formatPresetDateRange1 : ""
            }
        })
    });
};
